/* eslint-disable react/react-in-jsx-scope */
import i18n from "i18n";
import lod_ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import cockpitActions from "../../../redux/actions/cockpitActions";
import MessageItem from "../Message/MessageItem";
import { blue } from "@material-ui/core/colors";
import { Answers } from "../CockpitTabInfo/Answers";
import { Close } from "@material-ui/icons";

const {
	Dialog,
	Box,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Slider,
	Card,
	RadioGroup,
	FormControlLabel,
	Radio,
	LinearProgress,
	Switch,
	ListItemIcon,
	Divider,
	IconButton,
	TextField
} = require("@material-ui/core");
const { useState, useEffect } = require("react");

const TONALITY_LIST = [
	"cordial",
	"happily",
	"serious",
	"casual",
	"familiar",
	"formal",
	"polite",
	"professional"
];

const GenerateAnswerReply = ({ data = {}, open, actions, onClose }) => {
	const dispatch = useDispatch();
	const { selectedConversation } = useSelector(state => state.cockpit);

	const { assistantconfig, userStatus } = useSelector(state => state);
	const [selectedAnswer, setSelectedAnswer] = useState(null);
	const [tagsResponses, setTagsResponses] = useState([]);
	const [tag, setTag] = useState("none");
	const [selectedResponse, setSelectedResponse] = useState([]);
	const [currentAction, setCurrentAction] = useState(data);
	const cockpitSettings = useSelector(state => state?.userStatus?.auth?.user?.cockpitSettings);
	const { sortedBuiltInAnswers } = useSelector(state => state?.answers);
	let channel = assistantconfig.channels.find(
		c => c.code === selectedConversation.header.extra.channelCode
	);

	const quickGenerateAnswerEnabled = cockpitSettings?.quickGenerateAnswer === true;

	let review =
		cockpitSettings?.forceMessageSortNewerToOlder === true
			? selectedConversation.messages.find(m => m.header.source === "contact")
			: selectedConversation.messages.findLast(m => m.header.source === "contact");

	let defaultValues = channel?.answerGenerateConfig || {};

	const areAllConfigDisabled = () => {
		let allDisabled = true;
		let keys = Object.keys(defaultValues);
		keys.forEach(key => {
			if (defaultValues[key].active) {
				allDisabled = false;
			}
		});
		return allDisabled;
	};

	// DEFAULT VALUE
	const [payload, setPayload] = useState({
		emojisCount: defaultValues.emojisCount?.value ?? 0,
		answerTone: defaultValues.answerTone?.value ?? "professional",
		youForm: defaultValues.youForm?.value ?? "vouvoiement",
		maximumWords: defaultValues.maximumWords?.value ?? 50,
		temperature: defaultValues.temperature?.value ?? 0.5,
		translationAnswer: !lod_.isEmpty(defaultValues.translationAnswer?.value)
			? defaultValues.translationAnswer?.value
			: selectedConversation?.header?.language,
		recommendedResponseAnswer: defaultValues.recommendedResponseAnswer?.value ?? [],
		conversationData: defaultValues.conversationData?.value ?? [],
		draftAnswer: "",
		useEmbeddings: defaultValues.useEmbeddings?.value ?? {},
		llmModel: defaultValues.llmModel?.value ?? null
	});

	// New way | old way | default way
	const answers = selectedConversation?.meta?.generatedAnswers || [];

	const onChange = (path, value) => {
		setPayload(prev => {
			let clonedPayload = lod_.cloneDeep(prev);
			lod_.set(clonedPayload, path, value);
			return clonedPayload;
		});
	};

	// Start Action for generate reply with params
	const startActionReplyAssistant = action => {
		dispatch(
			cockpitActions.launchActionFrontV2(action?.code, {
				header: {
					assistantID: selectedConversation.header.assistantID,
					fID: selectedConversation.header.fID,
					mID: review?.header?.mID
				},
				payload: {
					processCode: action?.version === "2.0" ? action?.type : action?.config?.processCode,
					parameters: {
						message: review?.payload?.payload?.text?.plain_text, // KEVIN 01/09/2025 -> DATA TO DELETE IF USE MESSAGE IN LLM PROCESS
						rating: review?.payload?.payload?.rating,
						subject: review?.payload?.payload?.subject ?? "", // KEVIN 01/09/2025 -> DATA TO DELETE IF USE MESSAGE IN LLM PROCESS
						...payload
					},
					options: { ...defaultValues }
				}
			})
		);
		// onClose();
	};

	// Select answer to go in draft
	const selectAnswer = (forceIndex = null) => {
		const index = !lod_.isNil(forceIndex) ? forceIndex : selectedAnswer;
		let checkDraftAnswer = answers[index];

		if (typeof checkDraftAnswer !== "string") {
			checkDraftAnswer = checkDraftAnswer?.draftAnswerParts?.answer || "";
		}

		dispatch(
			cockpitActions.postDraft(
				selectedConversation.header.fID,
				selectedConversation.header.assistantID,
				selectedConversation.header.substate,
				{
					draftAnswer: checkDraftAnswer,
					draftAnswerParts: {
						answer: checkDraftAnswer,
						signature: selectedConversation?.drafts?.draftAnswerParts?.signature || "",
						replyTo: selectedConversation?.drafts?.draftAnswerParts?.replyTo || ""
					}
				}
			)
		);

		dispatch(
			cockpitActions.launchActionFrontV2("deleteGeneratedAnswers", {
				header: {
					assistantID: selectedConversation.header.assistantID,
					fID: selectedConversation.header.fID
				},
				payload: {
					actionUuid: currentAction.uuid
				}
			})
		);

		onClose();
	};

	useEffect(() => {
		if (quickGenerateAnswerEnabled && currentAction.state === "done" && answers.length > 0) {
			selectAnswer(0);
		}
	}, [currentAction.state, answers.length]);

	// delete response received from UND
	const deleteResponse = () => {
		// Remove response from conversation & frontend
		setCurrentAction({});
		dispatch(
			cockpitActions.launchActionFrontV2("deleteGeneratedAnswers", {
				header: {
					assistantID: selectedConversation.header.assistantID,
					fID: selectedConversation.header.fID
				},
				payload: {
					actionUuid: currentAction.uuid
				}
			})
		);
	};

	// onChange recommendedResponseAnswer values
	const changeRecommandedResponse = (event, code) => {
		const checked = event.target.checked;
		let copyArray = lod_.cloneDeep(selectedResponse);

		if (checked) {
			// Ajouter l'option sélectionnée au tableau
			if (!copyArray.includes(code)) {
				copyArray.push(code);
			}
		} else {
			// Retirer l'option désélectionnée du tableau
			copyArray = copyArray.filter(option => option !== code);
		}
		onChange(`recommendedResponseAnswer`, copyArray);
		setSelectedResponse(copyArray);
	};

	useEffect(() => {
		if (selectedConversation.actions) {
			if (currentAction.uuid) {
				let correctAction = selectedConversation.actions.find(a => a.uuid === currentAction.uuid);
				if (correctAction) {
					setCurrentAction(correctAction);
				}
			} else {
				let correctAction = selectedConversation.actions.find(
					a => a.code === "replyAssistant" && a.state === "processing"
				);
				if (correctAction) {
					setCurrentAction(correctAction);
				}
			}
		}
	}, [selectedConversation.actions]);

	useEffect(() => {
		if (!lod_.isEmpty(data)) {
			setCurrentAction(data);
		} else {
			setCurrentAction({});
			// Check if we have default generated answers in conversation.meta.generatedAnswers
			let generatedAnswers = selectedConversation.meta?.generatedAnswers;
			if (generatedAnswers) {
				setCurrentAction({
					result: {
						meta: { generatedAnswers }
					},
					state: "done",
					// Add a specific type to know that this action is computed
					// It will be used to dont delete an action when we click on "delete" button
					// => we will just change the state of current action
					type: "draftComputed"
				});
			}
		}
		setPayload({
			emojisCount: defaultValues.emojisCount?.value ?? 0,
			answerTone: defaultValues.answerTone?.value ?? "professional",
			youForm: defaultValues.youForm?.value ?? "vouvoiement",
			maximumWords: defaultValues.maximumWords?.value ?? 50,
			temperature: defaultValues.temperature?.value ?? 0.5,
			translationAnswer: !lod_.isEmpty(defaultValues.translationAnswer?.value)
				? defaultValues.translationAnswer?.value
				: selectedConversation?.header?.language,
			recommendedResponseAnswer: defaultValues.recommendedResponseAnswer?.value ?? [],
			conversationData: defaultValues.conversationData?.value ?? [],
			draftAnswer: "",
			useEmbeddings: defaultValues.useEmbeddings?.value ?? {},
			llmModel: defaultValues.llmModel?.value ?? null
		});
		setSelectedAnswer(null);
		setSelectedResponse([]);
	}, [open]);

	/**
	 * Gestion of name with new format action front v2
	 * Get language of profile to get correct action name or default to english or first available
	 */
	const buildActionName = action => {
		const language = userStatus?.auth?.user?.language?.toUpperCase();
		let nameOfAction = action.name;
		if (!lod_.isNil(action.actionName) && !lod_.isEmpty(action.actionName)) {
			if (!lod_.isNil(language) && !lod_.isNil(action.actionName[language])) {
				nameOfAction = action.actionName[language];
			} else {
				nameOfAction = action.actionName.EN ?? Object.values(action.actionName)[0] ?? action.name;
			}
		}

		return nameOfAction;
	};

	return (
		<Dialog
			fullWidth={true}
			onClose={onClose}
			maxWidth={"lg"}
			open={open}
			aria-labelledby="form-dialog-title"
		>
			<DialogTitle>{i18n.t(`COC.GenerateResponse`)}</DialogTitle>
			<DialogContent>
				{!quickGenerateAnswerEnabled && (
					<Box>
						{/* Message item */}
						{!lod_.isNil(review) && (
							<MessageItem
								message={review}
								msgIndex={1}
								fromHistoric={true}
								convHistory={selectedConversation}
							/>
						)}

						{/* Inputs title */}
						{!lod_.isEmpty(defaultValues) && !areAllConfigDisabled() && (
							<Box mt={3}>
								<Typography variant="h6" component="h2">
									{i18n.t(`COC.replyPrameters`)}
								</Typography>
							</Box>
						)}

						<Box
							style={{
								display: "grid",
								gridTemplateColumns: "repeat(4, 1fr)",
								gap: "15px",
								marginBottom: 20
							}}
						>
							{/* Inputs */}

							{/* Emojis */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.emojisCount?.display &&
								defaultValues?.emojisCount?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<Typography variant="body1" fontSize="small">
											{i18n.t("COC.ACTIONS.emojis")}
										</Typography>
										<Box>
											<Box mt={1} display="flex" alignItems="start">
												<Slider
													disabled={Boolean(currentAction.state)}
													value={payload.emojisCount}
													marks={[
														{
															value: 0,
															label: "0"
														},
														{
															value: 1,
															label: "1"
														},
														{
															value: 2,
															label: "2"
														},
														{
															value: 3,
															label: "3"
														},
														{
															value: 4,
															label: "4"
														},
														{
															value: 5,
															label: "5"
														}
													]}
													min={0}
													max={5}
													onChange={(e, value) => {
														onChange(`emojisCount`, value);
													}}
												/>
											</Box>
										</Box>
									</Card>
								)}

							{/* Tone */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.answerTone?.display &&
								defaultValues?.answerTone?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<FormControl fullWidth>
											<InputLabel id="select-label">{i18n.t("COC.ACTIONS.answerTone")}</InputLabel>
											<Select
												labelId="select-label"
												id="select"
												label={i18n.t("COC.ACTIONS.answerTone")}
												value={payload.answerTone}
												onChange={e => {
													onChange("answerTone", e.target.value);
												}}
												disabled={Boolean(currentAction.state)}
											>
												{TONALITY_LIST.map((option, index) => (
													<MenuItem key={index} value={i18n.t(`COC.ACTIONS.tonalities.${option}`)}>
														{i18n.t(`COC.ACTIONS.tonalities.${option}`)}
													</MenuItem>
												))}
											</Select>
										</FormControl>
									</Card>
								)}

							{/* Forme */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.youForm?.display &&
								defaultValues?.youForm?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<Typography variant="body1" fontSize="small">
											{i18n.t("COC.ACTIONS.youForm")}
										</Typography>
										<Box>
											<Box mt={1} flex="1" display="flex" alignItems="start">
												<RadioGroup
													aria-labelledby="demo-radio-buttons-group-label"
													value={payload.youForm}
													name="radio-buttons-group"
													row
												>
													<FormControlLabel
														value="vouvoiement"
														control={
															<Radio
																disabled={Boolean(currentAction.state)}
																color="primary"
																onClick={() => {
																	onChange(`youForm`, "vouvoiement");
																}}
															/>
														}
														label={i18n.t("COC.ACTIONS.vouvoiement")}
													/>
													<FormControlLabel
														value="tutoiement"
														control={
															<Radio
																disabled={Boolean(currentAction.state)}
																color="primary"
																onClick={() => {
																	onChange(`youForm`, "tutoiement");
																}}
															/>
														}
														label={i18n.t("COC.ACTIONS.tutoiement")}
													/>
												</RadioGroup>
											</Box>
										</Box>
									</Card>
								)}

							{/* Size */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.maximumWords?.display &&
								defaultValues?.maximumWords?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<Typography variant="body1" fontSize="small">
											{i18n.t("COC.ACTIONS.maximumWords")}
										</Typography>
										<Box>
											<Box mt={1}>
												<Slider
													aria-label="maximumWords"
													value={payload.maximumWords}
													step={10}
													min={20}
													max={100}
													onChange={(e, value) => {
														onChange(`maximumWords`, value);
													}}
													disabled={Boolean(currentAction.state)}
												/>

												<Box display="flex" justifyContent="space-between">
													<Typography variant="caption">{i18n.t("COC.ACTIONS.short")}</Typography>
													<Typography variant="caption">{i18n.t("COC.ACTIONS.long")}</Typography>
												</Box>
											</Box>
										</Box>
									</Card>
								)}

							{/* Temperature */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.temperature?.display &&
								defaultValues?.temperature?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<Typography variant="body1" fontSize="small">
											{i18n.t("COC.ACTIONS.temperature")}
										</Typography>
										<Box>
											<Box mt={1}>
												<Slider
													aria-label="temperature"
													value={payload.temperature}
													valueLabelDisplay="auto"
													step={0.1}
													min={0}
													max={2}
													onChange={(e, value) => {
														onChange(`temperature`, value);
													}}
													disabled={Boolean(currentAction.state)}
												/>

												<Box display="flex" justifyContent="space-between">
													<Typography variant="caption">{i18n.t("COC.ACTIONS.noCrea")}</Typography>
													<Typography variant="caption">
														{i18n.t("COC.ACTIONS.superCrea")}
													</Typography>
												</Box>
											</Box>
										</Box>
									</Card>
								)}

							{/* Translation */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.translationAnswer?.display &&
								defaultValues?.translationAnswer?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<Typography variant="body1" fontSize="small">
											{i18n.t("COC.ACTIONS.translationAnswer")}
										</Typography>
										<Box>
											<Box mt={1}>
												<FormControl fullWidth>
													<Select
														id="select"
														value={payload.translationAnswer}
														onChange={e => {
															onChange("translationAnswer", e.target.value);
														}}
														disabled={Boolean(currentAction.state)}
													>
														{assistantconfig.languages
															.filter(item => item.active === true)
															.map((item, index) => (
																<MenuItem key={`menu-option-${item.code}`} value={item.code}>
																	<ListItemIcon>
																		<img
																			src={item.logoURL}
																			alt={`Flag ${item.code}`}
																			width="30"
																			height="30"
																			style={{ objectFit: "contain" }}
																		/>
																	</ListItemIcon>
																	<span style={{ verticalAlign: "top" }}>
																		{i18n.t(`EDIT_FORM.languages.${item.code}`)}
																	</span>
																</MenuItem>
															))}
													</Select>
												</FormControl>
											</Box>
										</Box>
									</Card>
								)}

							{/* Recommended Response */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.recommendedResponseAnswer?.display &&
								defaultValues?.recommendedResponseAnswer?.active && (
									<Card style={{ padding: 20, height: "100%", gridColumn: "span 2" }}>
										<Typography variant="body1" fontSize="small">
											{i18n.t("COC.ACTIONS.recommendedResponseAnswer")}
										</Typography>
										<Box>
											<Box mt={1} style={{ width: "100%" }}>
												<Answers
													setTagsResponses={setTagsResponses}
													tagSelected={tag}
													setTag={setTag}
													selectedResponse={selectedResponse}
													setSelectedResponse={changeRecommandedResponse}
													onlyViewRecommandedResponse={true}
												/>
											</Box>
										</Box>
									</Card>
								)}

							{/* Use embeddings */}
							{!lod_.isEmpty(defaultValues) &&
								defaultValues?.useEmbeddings?.display &&
								defaultValues?.useEmbeddings?.active && (
									<Card style={{ padding: 20, height: "100%" }}>
										<Box
											display="flex"
											flexDirection="row"
											justifyContent="space-between"
											alignItems="center"
										>
											<Typography variant="body1" fontSize="small">
												{i18n.t("COC.ACTIONS.useEmbeddingsTitle")}
											</Typography>
											<Switch
												color="primary"
												checked={payload.useEmbeddings?.active}
												onChange={e => {
													onChange("useEmbeddings.active", e.target.checked);
												}}
												disabled={Boolean(currentAction.state)}
												inputProps={{ "aria-label": "controlled" }}
											/>
										</Box>
										<Typography variant="subtitle" fontSize="small">
											{i18n.t("COC.ACTIONS.useEmbeddingsDescription")}
										</Typography>
									</Card>
								)}
						</Box>

						<Divider
							style={{
								marginTop: 30,
								marginBottom: 30
							}}
						/>
					</Box>
				)}

				<Box style={{ flex: 1 }}>
					<Card style={{ padding: 20, height: "100%" }}>
						<Typography variant="body1" fontSize="small">
							{i18n.t("COC.ACTIONS.generateTextArea")}
						</Typography>
						<Box>
							<Box mt={1}>
								<TextField
									id="custom-text"
									value={payload.draftAnswer}
									onChange={e => onChange("draftAnswer", e.target.value)}
									fullWidth
									InputProps={{
										endAdornment: !lod_.isEmpty(payload.draftAnswer) && (
											<IconButton
												onClick={() => {
													onChange("draftAnswer", "");
												}}
												size="small"
											>
												<Close />
											</IconButton>
										)
									}}
									variant="outlined"
									multiline
									minRows={4}
									maxRows={4}
								/>
							</Box>
						</Box>
					</Card>
				</Box>

				{/* Waiting */}
				{!lod_.isEmpty(currentAction) && currentAction.state === "processing" && (
					<Box mt={3}>
						<Typography variant="h6" component="h2">
							{`Génération de propositions en cours`}
						</Typography>
						<Box mt={3}>
							<LinearProgress />
						</Box>
					</Box>
				)}
				{/* Error: quick mode done but no answers */}
				{currentAction.state === "done" && answers.length === 0 && (
					<Box mt={3}>
						<Typography variant="body1" color="error">
							{i18n.t("COC.generateAnswerFailed")}
						</Typography>
					</Box>
				)}
				{/* Results */}
				{!lod_.isEmpty(currentAction) &&
					!quickGenerateAnswerEnabled &&
					currentAction.state === "done" && (
						<>
							<Box mt={3}>
								<Typography variant="h6" component="h2">
									{`${answers.length} propositions générées`}
								</Typography>
							</Box>
							<Box mb={3}>
								<Typography variant="body1" component="h2">
									{`Selectionnez une proposition pour l'ajouter dans la zone de réponse`}
								</Typography>
							</Box>
							<Box
								style={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "space-between",
									alignItems: "stretch"
								}}
							>
								{answers.map((answer, index) => {
									return (
										<Box key={index} style={{ flex: 1 }}>
											<Card
												style={{
													marginRight: 5,
													marginLeft: 5,
													padding: 20,
													height: "100%",
													backgroundColor: selectedAnswer === index ? blue[600] : "white",
													color: selectedAnswer === index ? "white" : "black",
													fontWeight: selectedAnswer === index ? "bold" : "normal",
													cursor: "pointer",
													whiteSpace: "pre-wrap"
												}}
												onClick={() => {
													setSelectedAnswer(index);
												}}
												dangerouslySetInnerHTML={{
													__html:
														typeof answer === "string"
															? answer
															: answer?.draftAnswerParts?.answer || ""
												}}
											></Card>
										</Box>
									);
								})}
							</Box>
						</>
					)}
			</DialogContent>
			<DialogActions
				style={{
					display: "flex",
					justifyContent: "space-between"
				}}
			>
				<Box>
					{currentAction.state === "done" && answers.length > 0 && (
						<Button style={{ color: "red" }} onClick={deleteResponse}>
							{i18n.t("COC.Delete")}
						</Button>
					)}
				</Box>
				<Box>
					<Button style={{ color: "red" }} onClick={onClose}>
						{i18n.t("TabAction.cancel")}
					</Button>
					{lod_.isEmpty(currentAction) &&
						!lod_.isEmpty(actions) &&
						actions
							.filter(option => option.active === true)
							.map((option, index) => (
								<Button
									key={index}
									color="primary"
									autoFocus
									onClick={e => startActionReplyAssistant(option)}
								>
									{buildActionName(option)}
								</Button>
							))}

					{currentAction.state === "done" && answers.length === 0 && (
						<Button color="primary" autoFocus onClick={deleteResponse}>
							{i18n.t("COC.retry")}
						</Button>
					)}
					{!lod_.isEmpty(currentAction) &&
						!(currentAction.state === "done" && answers.length === 0) && (
							<Button
								color="primary"
								autoFocus
								onClick={() => selectAnswer()}
								disabled={selectedAnswer === null || currentAction.state !== "done"}
							>
								Utiliser
							</Button>
						)}
				</Box>
			</DialogActions>
		</Dialog>
	);
};

export default GenerateAnswerReply;
